export default {
  fontBlack: '"Metropolis-Black", sans-serif',
  fontBlackItalic: '"Metropolis-BlackItalic", sans-serif',
  fontBold: '"Metropolis-Bold", sans-serif',
  fontBoldItalic: '"Metropolis-BoldItalic", sans-serif',
  fontExtraBold: '"Metropolis-ExtraBold", sans-serif',
  fontExtraBoldItalic: '"Metropolis-ExtraBoldItalic", sans-serif',
  fontExtraLight: '"Metropolis-ExtraLight", sans-serif',
  fontExtraLightItalic: '"Metropolis-ExtraLightItalic", sans-serif',
  fontMedium: '"Metropolis-Medium", sans-serif',
  fontMediumItalic: '"Metropolis-MediumItalic", sans-serif',
  fontRegular: '"Metropolis-Regular", sans-serif',
  fontRegularItalic: '"Metropolis-RegularItalic", sans-serif',
  fontSemiBold: '"Metropolis-SemiBold", sans-serif',
  fontSemiBoldItalic: '"Metropolis-SemiBoldItalic", sans-serif',
  fontThin: '"Metropolis-Thin", sans-serif',
  fontThinItalic: '"Metropolis-ThinItalic", sans-serif'
};